export default {
  namespaced: true,
  // state: {
  //     /** enviroment */
  //     env: 'dev',
  //     // env: 'prod',

  //     /** */
  //     baseUrl: 'http://127.0.0.1:8000',
  //     // baseUrl: 'https://intranet-api.aupairkids.com.pe',

  //     /** */
  //     baseUrlToSignature: 'https://intranet-api.aupairkids.com.pe',
  // }

  state: {
    /** enviroment */
    //   env: 'dev',
    env: "prod",

    /** */
    //   baseUrl: 'http://127.0.0.1:8000',
    baseUrl: "https://intranet-api2.aupairkids.com.pe",

    /** */
    baseUrlToSignature: "https://intranet-api2.aupairkids.com.pe",
  },

  //   state: {
  //     env: process.env.NODE_ENV,

  //     baseUrl: process.env.VUE_APP_API_URL,

  //     baseUrlToSignature: "https://intranet-api.aupairkids.com.pe",
  //   },
};
